import Airplane from '@assets/images/initial/airplane.svg'
import AirportMap from '@assets/images/initial/airport-map.svg'
import AlertPanel from '@assets/images/initial/alert-panel.svg'
import BrigadeEditor from '@assets/images/initial/brigade-editor.svg'
import BrigadeMode from '@assets/images/initial/brigade-mode.svg'
import BrigadePlanMode from '@assets/images/initial/brigade-plan-mode.svg'
import CurrentTime from '@assets/images/initial/current-time.svg'
import EndBar from '@assets/images/initial/end-bar.svg'
import EventPanel from '@assets/images/initial/event-planet.svg'
import FlightList from '@assets/images/initial/flight-list.svg'
import Funnel from '@assets/images/initial/funnel.svg'
import LinkedTasks from '@assets/images/initial/linked-tasks.svg'
import Minus from '@assets/images/initial/minus.svg'
import Plus from '@assets/images/initial/plus.svg'
import Printer from '@assets/images/initial/printer.svg'
import ResourceView from '@assets/images/initial/resource-view.svg'
import ResourceViewCut from '@assets/images/initial/resource-view-cut.svg'
import ResourceViewCutFilter from '@assets/images/initial/resource-view-cut-filter.svg'
import ResourceViewFilter from '@assets/images/initial/resource-view-filter.svg'
import Scale100 from '@assets/images/initial/scale100.svg'
import SearchAssistant from '@assets/images/initial/search-assistant.svg'
import StartBar from '@assets/images/initial/start-bar.svg'
import SystemAlertPanel from '@assets/images/initial/system-alert-panel.svg'
import TaskView from '@assets/images/initial/task-view.svg'

import { IconType } from '@components/AppBar/components/IconSection'

export const INITIAL_ICONS: Record<string, IconType> = {
  Printser: {
    name: 'Printser',
    src: Printer,
  },
  Scale100: {
    name: 'Scale100',
    src: Scale100,
  },
  Plus: {
    name: 'Plus',
    src: Plus,
  },
  Minus: {
    name: 'Minus',
    src: Minus,
  },
  StartBar: {
    name: 'StartBar',
    src: StartBar,
  },
  CurrentTime: {
    name: 'CurrentTime',
    src: CurrentTime,
  },
  EndBar: {
    name: 'EndBar',
    src: EndBar,
  },
  Funnel: {
    name: 'Funnel',
    src: Funnel,
  },
  ResourceViewFilter: {
    name: 'ResourceViewFilter',
    src: ResourceViewFilter,
  },
  ResourceViewCut: {
    name: 'ResourceViewCut',
    src: ResourceViewCut,
  },
  ResourceViewCutFilter: {
    name: 'ResourceViewCutFilter',
    src: ResourceViewCutFilter,
  },
  SearchAssistant: {
    name: 'SearchAssistant',
    src: SearchAssistant,
  },
  FlightList: {
    name: 'FlightList',
    src: FlightList,
  },
  BrigadeEditor: {
    name: 'BrigadeEditor',
    src: BrigadeEditor,
  },
  BrigadeMode: {
    name: 'BrigadeMode',
    src: BrigadeMode,
  },
  BrigadePlanMode: {
    name: 'BrigadePlanMode',
    src: BrigadePlanMode,
  },
  LinkedTasks: {
    name: 'LinkedTasks',
    src: LinkedTasks,
  },
  AlertPanel: {
    name: 'AlertPanel',
    src: AlertPanel,
  },
  EventPanel: {
    name: 'EventPanel',
    src: EventPanel,
  },
  SystemAlertPanel: {
    name: 'SystemAlertPanel',
    src: SystemAlertPanel,
  },
  AirportMap: {
    name: 'AirportMap',
    src: AirportMap,
  },
  Airplane: {
    name: 'Airplane',
    src: Airplane,
  },
  ResourceView: {
    name: 'ResourceView',
    src: ResourceView,
  },
  TaskView: {
    name: 'TaskView',
    src: TaskView,
  },
}
